import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { DialogService } from '@technocom/ui/dialogs';
import { NotificationService } from '@technocom/common';
import { isUndefined } from 'lodash';

@Component({
  selector: 'app-action-form-button',
  templateUrl: './action-form-button.component.html',
  styleUrls: ['./action-form-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionFormButtonComponent implements OnInit {
  @Input() control: AbstractControl;
  @Input() historyValue: any;
  @Input() editMessage: string;

  constructor(
    protected dialogService: DialogService,
    protected notificationService: NotificationService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.control.statusChanges.subscribe(e => {
      this.cd.markForCheck();
    });
  }

  edit() {
    if (this.editMessage) {
      this.dialogService.confirm(this.editMessage).subscribe({
        complete: () => {
          this.control.enable();
          this.cd.markForCheck();
        },
      });
    } else {
      this.control.enable();
      this.cd.markForCheck();
    }
  }

  undo() {
    this.control.patchValue(this.historyValue);
    this.control.disable();
    this.control.markAsPristine();
  }

  isShowEdit(): boolean {
    return !this.control.enabled;
  }

  isShowUndo(): boolean {
    return !isUndefined(this.historyValue) && this.historyValue !== this.control.value && this.control.enabled;
  }
}
